export default __webpack_public_path__ + "static/media/icon_19.2fdf06ea.png";